



































import { defineComponent } from '@nuxtjs/composition-api';
import SfIcon from './SfIcon.vue';
import SfLink from './SfLink.vue';
import SfButton from './SfButton/SfButton.vue';

export default defineComponent({
  name: 'SfMenuItem',
  components: {
    SfIcon,
    SfLink,
    SfButton,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: [String, Array],
      default: 'chevron_right',
    },
    count: {
      type: [String, Number],
      default: '',
    },
    link: {
      type: [String, Object],
      default: null,
    },
  },
  computed: {
    bind() {
      const bind: any = {};
      if (this.link) {
        bind.link = this.link;
      } else {
        bind.class = 'sf-button--pure';
      }
      return bind;
    },
    componentIs(this: { link: any }) {
      return this.link ? 'SfLink' : 'SfButton';
    },
  },
});
